import React, { useState } from 'react';
import { seoContentData } from './seoContentData';
import { useLanguage, getTranslation } from '../utils/translations';

const SEOContentSection = ({ pageType }) => {
  const lang = useLanguage();
  const data = seoContentData[pageType]?.[lang] || seoContentData[pageType]?.en;

  if (!data) return null;

  const { features, howTo, faq } = data;

  const sectionLabels = {
    en: { features: 'Why Use This Tool?', howTo: 'How It Works', faq: 'Frequently Asked Questions' },
    fr: { features: 'Pourquoi utiliser cet outil ?', howTo: 'Comment ça marche', faq: 'Questions fréquemment posées' },
  };
  const labels = sectionLabels[lang] || sectionLabels.en;

  return (
    <section className="w-full max-w-4xl mx-auto px-4 sm:px-6 py-10 text-left" aria-label="Tool information">

      {/* Features */}
      {features && features.length > 0 && (
        <div className="mb-10">
          <h2 className="text-xl sm:text-2xl font-semibold text-[#323232] mb-4">{labels.features}</h2>
          <ul className="space-y-2">
            {features.map((f, i) => (
              <li key={i} className="flex items-start gap-2 text-gray-700">
                <span className="text-green-500 mt-1 flex-shrink-0">✓</span>
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* How-To Steps */}
      {howTo && howTo.length > 0 && (
        <div className="mb-10">
          <h2 className="text-xl sm:text-2xl font-semibold text-[#323232] mb-4">{labels.howTo}</h2>
          <ol className="space-y-4">
            {howTo.map((step, i) => (
              <li key={i} className="flex items-start gap-4">
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-[#323232] text-white flex items-center justify-center text-sm font-bold">
                  {i + 1}
                </span>
                <div>
                  <h3 className="font-medium text-[#323232]">{step.title}</h3>
                  <p className="text-gray-600 text-sm mt-1">{step.description}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      )}

      {/* FAQ Accordion */}
      {faq && faq.length > 0 && (
        <div className="mb-6">
          <h2 className="text-xl sm:text-2xl font-semibold text-[#323232] mb-4">{labels.faq}</h2>
          <div className="space-y-2">
            {faq.map((item, i) => (
              <details
                key={i}
                className="border border-gray-200 rounded-lg overflow-hidden group"
              >
                <summary className="cursor-pointer px-4 py-3 bg-gray-50 hover:bg-gray-100 font-medium text-[#323232] transition-colors list-none flex items-center justify-between">
                  <span>{item.q}</span>
                  <span className="text-gray-400 group-open:rotate-180 transition-transform">▼</span>
                </summary>
                <div className="px-4 py-3 text-gray-600 text-sm leading-relaxed">
                  {item.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default SEOContentSection;
